import React, { forwardRef } from 'react';
import MUICardMedia, {
  CardMediaProps as MUICardMediaProps,
} from '@material-ui/core/CardMedia';

export interface CardMediaProps extends MUICardMediaProps {}

const CardMedia = forwardRef<HTMLDivElement, CardMediaProps>((props, ref) => {
  return <MUICardMedia {...props} ref={ref} />;
});

CardMedia.displayName = 'CardMedia';

export default CardMedia;
